import packageInfo from '../../package.json';

/**
 * Gets the application version number
 *
 * @returns zero-filled version number
 */
export const versionNumber = () => {
    return formatVersionNumber(packageInfo.version);
};

/**
 * Formats a version number to X.XX.XX
 *
 * @param version version number to format
 */
export const formatVersionNumber = (version: string) => {
    if (version) {
        const versionParts = version.split('.');

        if (versionParts.length > 2) {
            const majorVersion = versionParts[0];
            const minorVersion = versionParts[1].length < 2 ? '0' + versionParts[1] : versionParts[1];
            const patchVersion = versionParts[2].length < 2 ? '0' + versionParts[2] : versionParts[2];

            return majorVersion + '.' + minorVersion + '.' + patchVersion;
        }
    }

    return ' ';
};